<div class="underguard" [ngClass]="{'hidden': hideComponents}"></div>
<div class="podcastpage-image-background over" [ngClass]="{'hidden': hideComponents}">
  <div class="mouse-blocker" [ngClass]="{'hidden': hideComponents}"></div>
  <div #heroImage class="background-holder"
  [responsiveBackgroundImage]="bgImageToUse"></div>
</div>
<div class="podcastpage-image-background under" [ngClass]="{'hidden': hideComponents}">
  <div class="background-holder" 
  [responsiveBackgroundImage]="bgImageToUse"></div>
</div>
<div class="podcastpage-image-placeholder"></div>
<section class="podcasts-list-container" *ngIf="shows">
  <tyt-podcast-item 
    *ngFor="let show of shows"
    [attr.data-show]="show.id"
    [class.above-the-fold]="isAboveFold(show)"
    [class.active]="topShowId === show.id"
    [show]="show">
  </tyt-podcast-item>
</section>
